export const ALLERGEN_SUGGESTIONS = ['גלוטן', 'ביצים', 'חלב', 'שומשום', 'אגוזים', 'בוטנים', 'סויה', 'דגים', 'סלרי', 'חרדל'];
export const TAG_SUGGESTIONS = ['צמחוני', 'טבעוני', 'ללא גלוטן', 'חריף', 'חריף קל', 'ללא לקטוז'];
export const SUCCESS_TAGS = new Set(['צמחוני', 'טבעוני']);
